require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/forms.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/forms.legacy.js
// module id = 630
// module chunks = 31